import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FaTags, FaPercentage, FaDollarSign } from 'react-icons/fa';
import './CouponType.scss';

interface CouponTypeProps {
  couponType: string;
  setCouponType: (val: string) => void;
  couponAmount: number | null;
  setCouponAmount: (val: number | null) => void;
  couponPercentage: number | null;
  setCouponPercentage: (val: number | null) => void;
  amountError: string;
}

const CouponType: React.FC<CouponTypeProps> = ({
  couponType,
  setCouponType,
  couponAmount,
  setCouponAmount,
  couponPercentage,
  setCouponPercentage,
  amountError
}) => {
  return (
    <div className="form-section coupon-type-section">
      <div className="section-title">
        <FaTags className="section-icon" />
        Tipo de descuento
      </div>
      <div className="type-selection">
        <div
          className={`type-option ${couponType === 'Percentage' ? 'active' : ''}`}
          onClick={() => { setCouponType('Percentage'); setCouponAmount(null); }}
        >
          <div className="type-header">
            <div className="type-icon"><FaPercentage /></div>
            <div className="type-title">Porcentaje</div>
          </div>
          <div className="type-description">Basado en porcentaje del total</div>
        </div>
        <div
          className={`type-option ${couponType === 'Amount' ? 'active' : ''}`}
          onClick={() => { setCouponType('Amount'); setCouponPercentage(null); }}
        >
          <div className="type-header">
            <div className="type-icon"><FaDollarSign /></div>
            <div className="type-title">Monto fijo</div>
          </div>
          <div className="type-description">Descuento de cantidad fija en pesos</div>
        </div>
      </div>
      {couponType && (
        <div className="amount-input-container">
          {couponType === 'Percentage' ? (
            <InputGroup>
              <Form.Control
                type="number"
                min={1}
                max={99}
                value={couponPercentage !== null ? couponPercentage : ''}
                onChange={(e) => setCouponPercentage(Math.max(1, Math.min(99, Number(e.target.value))))}
                required
                placeholder="Porcentaje de descuento (Ej: 15)"
              />
              <InputGroup.Text className="signo">%</InputGroup.Text>
            </InputGroup>
          ) : (
            <InputGroup>
              <InputGroup.Text className="signo">$</InputGroup.Text>
              <Form.Control
                type="number"
                min={0}
                value={couponAmount !== null ? couponAmount : ''}
                onChange={(e) => setCouponAmount(Math.max(0, Number(e.target.value)))}
                required
                placeholder="Monto de descuento (Ej: 1000)"
                isInvalid={!!amountError}
              />
            </InputGroup>
          )}
          {amountError && <div className="error-message">{amountError}</div>}
        </div>
      )}
    </div>
  );
};

export default CouponType;
